@use '../../../../../styles/Constants.scss' as Constants;

.badges-container {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translate(50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	z-index: 3;

	&__overlap-badges > :nth-child(2) {
		position: absolute;
		left: 0;
		top: 10px;
		z-index: 2;
	}
}
$indicator-size: 4px;
$indicator-gap: 6px;

.crew-lead-indicator {
	position: absolute;
	left: Constants.$val-spacing-xxs;
	bottom: calc(#{$indicator-size} + #{$indicator-gap} + #{$indicator-size});
	width: $indicator-size;
	height: $indicator-size;
	background-color: #000;
}